import { render, staticRenderFns } from "./ParamTipoRodadoForm.vue?vue&type=template&id=29e36db2"
import script from "./ParamTipoRodadoForm.vue?vue&type=script&lang=js"
export * from "./ParamTipoRodadoForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports